import * as React from "react";
import { forwardRef } from "react";
const ArrowExpandDownSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M3.247 6.342a1 1 0 0 1 1.412-.095L8 9.171l3.342-2.924a1 1 0 0 1 1.316 1.506l-4 3.5a1 1 0 0 1-1.316 0l-4-3.5a1 1 0 0 1-.095-1.411", clipRule: "evenodd" }));
const ForwardRef = forwardRef(ArrowExpandDownSVG);
export default ForwardRef;
//# sourceMappingURL=ArrowExpandDown.js.map